const theme = {
    isBuiltIn: true,
    id: "horizon",
    name: "Horizon",
    backgroundGradients: [
        {
            angle: 0,
            colorStyle: "dark",
            id: "0f346dc6-d9c2-497b-98ac-3653c1d96164",
            noise: 0,
            stops: [
                {
                    color: "#000000",
                    position: 0
                },
                {
                    color: "#003034",
                    position: 100
                }
            ],
            type: "linear"
        },
        {
            angle: 0,
            colorStyle: "dark",
            id: "7e6541ed-4b75-4b08-871f-e798d4102f7a",
            noise: 0,
            stops: [
                {
                    color: "#000000",
                    position: 0
                },
                {
                    color: "#4D0F30",
                    position: 100
                }
            ],
            type: "linear"
        }
    ],
    collectionColors: [
        {
            colors: [
                "theme",
                "accent1",
                "accent2",
                "accent3",
                "accent4",
                "accent5"
            ],
            endColor: "accent3",
            id: "colorful",
            startColor: "theme",
            type: "gradient"
        },
        {
            colors: [
                "theme",
                "accent1",
                "accent2",
                "accent3",
                "accent4",
                "accent5",
                "accent6",
                "accent7",
                "accent8"
            ],
            endColor: "accent1",
            id: "98c382d2-a9f2-405d-b20b-03c6e6663f62",
            startColor: "accent3",
            type: "gradient"
        },
        {
            colors: [
                "theme",
                "accent1",
                "accent2",
                "accent3",
                "accent4",
                "accent5",
                "accent6",
                "accent7",
                "accent8"
            ],
            endColor: "accent1",
            id: "c56481c7-052b-4281-9927-a47eba21b9e8",
            startColor: "theme",
            type: "sequence"
        }
    ],
    cjkFont: "jp",
    colors: {
        accent1: "rgba(1,160,200,1)",
        accent2: "rgba(96,130,230,1)",
        accent3: "rgba(135,108,215,1)",
        accent4: "rgba(226,90,128,1)",
        accent5: "rgba(218,70,68,1)",
        accent6: "rgba(217,92,58,1)",
        accent7: "rgba(217,122,1,1)",
        accent8: "rgba(218,176,59,1)",
        background_accent: "rgba(17,17,17,1)",
        background_dark: "rgba(0,0,0,1)",
        background_light: "#ffffff",
        chart1: "rgba(0,159,162,1)",
        chart2: "rgba(218,176,59,1)",
        chart3: "rgba(1,160,200,1)",
        chart4: "rgba(217,122,1,1)",
        chart5: "rgba(96,130,230,1)",
        chart6: "rgba(217,92,58,1)",
        chart7: "rgba(135,108,215,1)",
        hart8: "rgba(226,90,128,1)",
        chart9: "rgba(218,70,68,1)",
        hyperlink: "rgba(0,159,162,1)",
        egative: "rgba(218,70,68,1)",
        positive: "rgba(0,159,162,1)",
        primary_dark: "rgba(51,51,51,1)",
        primary_light: "rgba(255,255,255,1)",
        secondary_dark: "rgba(0,0,0,0.65)",
        secondary_light: "rgba(255,255,255,0.8)",
        theme: "rgba(0,159,162,1)"
    },
    defaultBackgroundColor: "0f346dc6-d9c2-497b-98ac-3653c1d96164",
    defaultSlideColor: "theme",
    imageStyle: "custom",
    imageStylePrompt: "Clean composition, smooth gradients, crisp geometry, technical details.",
    fontBodyFontId: "dmmono",
    fontBodyLetterSpacing: -0.02,
    fontBodyLineHeight: 2,
    fontBodyScaling: 100,
    fontBodyTextTransform: "auto",
    fontBodyWeight: 400,
    fontHeaderFontId: "satoshi",
    fontHeaderLetterSpacing: -0.06,
    fontHeaderLineHeight: 1.6,
    fontHeaderScaling: 100,
    fontHeaderTextTransform: "auto",
    fontHeaderWeight: 900,
    fontScale: 1,
    fontTitleFontId: "satoshi",
    fontTitleLetterSpacing: -0.06,
    fontTitleLineHeight: 1.6,
    fontTitleScaling: 100,
    fontTitleTextTransform: "auto",
    fontTitleWeight: 900,
    footerMessage: `${new Date().getFullYear()} Proprietary and Confidential. All Rights Reserved.`,
    iconStyle: "classic",
    isRTL: false,
    logoOffset: 0,
    logoPosition: "left",
    logoScale: 1,
    palette_name: "custom",
    showFooterByDefault: true,
    showLogo: true,
    showMessage: false,
    showPageNum: true,
    styleBackground: "none",
    styleBodyFont: "sourcesanspro",
    styleDecoration: "none_left",
    styleDesign: 1,
    styleEffect: "none",
    styleElementStyle: "outlined",
    styleFontWeight: "heavy",
    styleShape: "circle",
    styleTitleFont: "bebasneue",
    styleTitleSlide: "bar_left",
    styleWeight: "medium",
    defaultSlides: {

        "section": "{\"textStylesVersion\":2,\"layout\":{\"backgroundStyle\":\"backgroundGradient\",\"backgroundColor\":\"7e6541ed-4b75-4b08-871f-e798d4102f7a\"},\"states\":[{\"primary\":{\"text\":{\"blocks\":[{\"type\":\"text\",\"html\":\"Section 1\",\"textStyle\":\"label\",\"id\":\"794d2c73-e89a-46f7-99ed-59d3b2bc2360\",\"indent\":0,\"blockBounds\":{\"left\":0,\"top\":-4.734375,\"width\":439,\"height\":22.90625},\"textStyles\":{\"fontFamily\":\"satoshi\",\"baseFontSize\":20,\"fontColor\":\"primary\",\"bulletScale\":1,\"bulletSpacing\":2.5,\"bulletIndent\":50,\"fontScaling\":100,\"fontWeight\":900,\"letterSpacing\":\"-0.06em\",\"lineHeight\":1.1455999755859376,\"textTransform\":\"none\",\"spaceBelow\":0,\"spaceAbove\":0,\"blockSpacing\":30,\"maxLines\":9999,\"evenBreak\":false,\"listDecorationStyle\":\"theme\",\"allowFancyNumberedDecorations\":false,\"hasEmphasized\":false,\"blockInset\":0,\"isRTL\":false,\"fontScale\":1,\"fontSize\":20,\"textAlign\":\"center\",\"color\":\"rgb(255, 255, 255)\",\"emphasizedColor\":\"rgb(255, 255, 255)\",\"hyperlinkColor\":\"rgb(0, 159, 162)\"},\"blockMargin\":{\"top\":-4.73600006103516,\"bottom\":0,\"left\":0,\"right\":0},\"topSpace\":4.73600006103516,\"bottomSpace\":3.8559997558593757},{\"id\":\"57fdbf62-6c9b-4667-aaa8-3976a1f75278\",\"type\":\"text\",\"textStyle\":\"headline\",\"html\":\"\",\"indent\":0,\"blockBounds\":{\"left\":0,\"top\":29.234375,\"width\":439,\"height\":80.546875},\"textStyles\":{\"fontFamily\":\"satoshi\",\"baseFontSize\":75,\"fontColor\":\"primary\",\"bulletScale\":1,\"bulletSpacing\":2.5,\"bulletIndent\":50,\"fontScaling\":100,\"fontWeight\":900,\"letterSpacing\":\"-0.06em\",\"lineHeight\":1.0739999771118165,\"textTransform\":\"none\",\"spaceBelow\":0,\"spaceAbove\":0,\"blockSpacing\":30,\"maxLines\":9999,\"evenBreak\":true,\"listDecorationStyle\":\"theme\",\"allowFancyNumberedDecorations\":false,\"hasEmphasized\":false,\"blockInset\":0,\"isRTL\":false,\"fontScale\":1,\"fontSize\":75,\"textAlign\":\"center\",\"color\":\"rgb(255, 255, 255)\",\"emphasizedColor\":\"rgb(0, 159, 162)\",\"hyperlinkColor\":\"rgb(0, 159, 162)\",\"boldStyles\":{\"fontColor\":\"slide\"},\"accentColor\":\"theme\"},\"blockMargin\":{\"top\":11.068999958038315,\"bottom\":-11.774999141693101,\"left\":0,\"right\":0},\"topSpace\":15.07500028610231,\"bottomSpace\":11.774999141693101,\"hyphenation\":false,\"ligatures\":true,\"accentColor\":\"theme\"}]},\"backdropPadding\":30,\"verticalAlign\":\"middle\",\"accentColor\":\"theme\",\"headlinePosition\":\"right\",\"items\":[{\"componentType\":\"TextAndImage\",\"childElement\":{\"content_type\":\"image\",\"assetProps\":{\"originalSize\":{\"width\":926,\"height\":926}},\"assetName\":\"iso rocket dashboard\",\"content_value\":\"43aa612d6c5a749f9eb821f0677c1c6b543619f14c01ded91327f4f1039dfbd9-I\",\"flipHorizontal\":false,\"mediaOpacity\":1,\"aoiLeft\":0,\"aoiRight\":926,\"aoiTop\":28.118916744872024,\"aoiBottom\":897.881083255128,\"scale\":0.712838548137388,\"version\":1,\"assetWidth\":926,\"assetHeight\":926,\"isDefaultTransform\":true},\"id\":\"cf59a587-a5c5-4b84-8c0e-bdcf1b5374be\"}],\"gridLayout\":{\"cols\":12,\"rows\":12,\"cells\":[{\"x\":0,\"y\":0,\"width\":12,\"height\":12}]},\"dividerSize\":0.44060296985150743},\"callouts\":{\"elements\":[],\"collectionColor\":\"theme\",\"snapToGrid\":false,\"connections\":{\"items\":[],\"collectionColor\":\"theme\"}}}],\"animations\":{},\"template_id\":\"section\",\"migrationVersion\":10.03,\"version\":10}",
        "title": "{\"textStylesVersion\":2,\"layout\":{},\"states\":[{\"primary\":{\"showFooter\":false,\"text\":{\"blocks\":[{\"id\":\"79ebc938-56d4-4f6b-8b14-c3ddeced18d8\",\"html\":\"\",\"type\":\"text\",\"textStyle\":\"label\",\"indent\":0,\"blockBounds\":{\"left\":0,\"top\":-5.4453125,\"width\":604.8828125,\"height\":26.34375},\"textStyles\":{\"fontFamily\":\"satoshi\",\"baseFontSize\":23,\"fontColor\":\"secondary\",\"bulletScale\":1,\"bulletSpacing\":2.5,\"bulletIndent\":50,\"fontScaling\":100,\"fontWeight\":900,\"letterSpacing\":\"-0.06em\",\"lineHeight\":1.1455999755859374,\"textTransform\":\"uppercase\",\"spaceBelow\":0,\"spaceAbove\":0,\"blockSpacing\":40,\"maxLines\":9999,\"evenBreak\":false,\"listDecorationStyle\":\"theme\",\"allowFancyNumberedDecorations\":false,\"hasEmphasized\":false,\"blockInset\":0,\"isRTL\":false,\"fontScale\":1,\"fontSize\":23,\"textAlign\":\"left\",\"color\":\"rgba(255, 255, 255, 0.8)\",\"emphasizedColor\":\"rgb(255, 255, 255)\",\"hyperlinkColor\":\"rgb(0, 159, 162)\"},\"blockMargin\":{\"top\":-5.44640007019043,\"bottom\":0,\"left\":0,\"right\":0},\"topSpace\":5.44640007019043,\"bottomSpace\":4.434399719238279},{\"id\":\"b51274db-7837-4e11-9028-9b1d51530dc2\",\"type\":\"text\",\"html\":\"\",\"textStyle\":\"heading\",\"indent\":0,\"blockBounds\":{\"left\":0,\"top\":35.1484375,\"width\":470.4375,\"height\":206.203125},\"textStyles\":{\"fontFamily\":\"satoshi\",\"baseFontSize\":90,\"fontColor\":\"primary\",\"bulletScale\":1,\"bulletSpacing\":2.5,\"bulletIndent\":50,\"fontScaling\":100,\"fontWeight\":900,\"letterSpacing\":\"-0.06em\",\"lineHeight\":1.1455999755859376,\"textTransform\":\"none\",\"spaceBelow\":0,\"spaceAbove\":0,\"blockSpacing\":40,\"boldStyles\":{\"fontColor\":\"slide\"},\"maxLines\":9999,\"evenBreak\":true,\"listDecorationStyle\":\"theme\",\"allowFancyNumberedDecorations\":false,\"hasEmphasized\":false,\"blockInset\":0,\"isRTL\":false,\"fontScale\":1,\"fontSize\":90,\"textAlign\":\"left\",\"color\":\"rgb(255, 255, 255)\",\"emphasizedColor\":\"rgb(0, 159, 162)\",\"hyperlinkColor\":\"rgb(0, 159, 162)\",\"accentColor\":\"theme\"},\"blockMargin\":{\"top\":14.253600006103511,\"bottom\":0,\"left\":0,\"right\":0},\"topSpace\":21.31200027465821,\"bottomSpace\":17.351998901367196,\"hyphenation\":false,\"ligatures\":true,\"fontScale\":1},{\"id\":\"1c89190c-524b-40c7-9d23-ccc28e975a48\",\"type\":\"text\",\"html\":\"\",\"textStyle\":\"body\",\"indent\":0,\"blockBounds\":{\"left\":0,\"top\":255.0859375,\"width\":604.8828125,\"height\":37.796875},\"textStyles\":{\"fontFamily\":\"dmmono\",\"baseFontSize\":27,\"fontColor\":\"secondary\",\"bulletScale\":1,\"bulletSpacing\":2.5,\"bulletIndent\":50,\"fontScaling\":100,\"fontWeight\":400,\"letterSpacing\":\"-0.02em\",\"lineHeight\":1.4,\"textTransform\":\"none\",\"spaceBelow\":0,\"spaceAbove\":0,\"blockSpacing\":40,\"boldStyles\":{\"fontColor\":\"primary\"},\"maxLines\":9999,\"evenBreak\":false,\"listDecorationStyle\":\"theme\",\"allowFancyNumberedDecorations\":false,\"hasEmphasized\":false,\"blockInset\":0,\"isRTL\":false,\"fontScale\":1,\"fontSize\":27,\"textAlign\":\"left\",\"color\":\"rgba(255, 255, 255, 0.8)\",\"emphasizedColor\":\"rgb(255, 255, 255)\",\"hyperlinkColor\":\"rgb(0, 159, 162)\"},\"blockMargin\":{\"top\":13.738001098632804,\"bottom\":-9.989999999999998,\"left\":0,\"right\":0},\"topSpace\":8.91,\"bottomSpace\":9.989999999999998}]},\"textAlign\":\"left\",\"verticalAlign\":\"top\",\"accentColor\":\"theme\",\"image\":{\"content_type\":\"image\",\"assetProps\":{\"originalSize\":{\"width\":923,\"height\":926}},\"assetName\":\"iso tech\",\"content_value\":\"0be9ca4220431278ec0a920222c6e598844362cc7d9f808754b0c00883044dd2-I\",\"flipHorizontal\":false,\"mediaOpacity\":1,\"aoiLeft\":0,\"aoiRight\":923,\"aoiTop\":208.814453125,\"aoiBottom\":717.185546875,\"scale\":1.3867822318526544,\"position\":\"background\",\"version\":1,\"assetWidth\":923,\"assetHeight\":926,\"isDefaultTransform\":false},\"backdropStyle\":\"none\",\"textPosition\":\"top_left\",\"presenters\":{\"textStyle\":\"transparent_dark_box\",\"items\":[{\"title\":\"\",\"id\":\"f8a8408b-03e9-4081-aa62-9d3ab7b0e1ff\",\"text\":{\"blocks\":[{\"id\":\"c4824811-83a8-406b-91ec-005ef14ce6a2\",\"html\":\"\",\"type\":\"text\",\"textStyle\":\"title\",\"indent\":0,\"blockBounds\":{\"left\":0,\"top\":-4.734375,\"width\":121,\"height\":22.90625},\"textStyles\":{\"fontFamily\":\"satoshi\",\"baseFontSize\":20,\"fontColor\":\"primary\",\"bulletScale\":1,\"bulletSpacing\":2.5,\"bulletIndent\":50,\"fontScaling\":100,\"fontWeight\":900,\"letterSpacing\":\"-0.06em\",\"lineHeight\":1.1455999755859376,\"textTransform\":\"none\",\"spaceBelow\":0,\"spaceAbove\":0,\"blockSpacing\":20,\"boldStyles\":{\"fontColor\":\"slide\"},\"maxLines\":2,\"evenBreak\":false,\"listDecorationStyle\":\"theme\",\"allowFancyNumberedDecorations\":false,\"hasEmphasized\":false,\"blockInset\":0,\"isRTL\":false,\"fontScale\":1,\"fontSize\":20,\"textAlign\":\"left\",\"color\":\"rgb(255, 255, 255)\",\"emphasizedColor\":\"rgb(0, 159, 162)\",\"hyperlinkColor\":\"rgb(0, 159, 162)\"},\"blockMargin\":{\"top\":-4.73600006103516,\"bottom\":-3.8559997558593757,\"left\":0,\"right\":0},\"topSpace\":4.73600006103516,\"bottomSpace\":3.8559997558593757}]}}],\"collectionColor\":\"theme\"},\"showPresenters\":true,\"decoration\":\"none\",\"shadow\":{\"x\":0,\"y\":0,\"blur\":10,\"color\":\"black\",\"opacity\":0.4},\"userWidth\":604.8882501130417,\"backdropPadding\":40},\"callouts\":{\"elements\":[],\"collectionColor\":\"theme\",\"snapToGrid\":false,\"connections\":{\"items\":[],\"collectionColor\":\"theme\"}}}],\"animations\":{},\"template_id\":\"title\",\"migrationVersion\":10.03,\"version\":10}"

    }
};

module.exports = theme;
